import { ReactElement, ReactNode } from 'react';
import { Accept } from 'react-dropzone';

import {
    DocumentArrowUpOutlinedSize32,
    DocumentOutlinedSize32,
    VideocameraOutlinedSize32,
    ImageSize32,
    DocumentArrowUpOutlinedSize24,
    DocumentOutlinedSize24,
    VideocameraOutlinedSize24,
    ImageSize24,
} from '@hh.ru/magritte-ui-icon/icon';
import { LoadedFile, UploadType, LoadedFileWithFileSize } from '@hh.ru/magritte-ui-upload/types';

export const RenderFileInfoDefault = (loadedFile: LoadedFileWithFileSize): ReactNode => {
    return loadedFile.fileSizeMB;
};

export const DEFAULT_ACCEPT: Accept = {
    'image/*': ['.png', '.jpeg', '.jpg'],
};

const order = 1024 * 1024;
export const bytes2mb = (value: number): string => {
    return (value / order).toFixed(2);
};

export const getFileType = (avaliableType: string): UploadType => {
    return avaliableType.split('/')[0] as UploadType;
};

// парсим accept в нормальный формат
export const getAvaliableFileTypes = (accept: Accept): UploadType => {
    const avaliableTypes = Object.keys(accept);
    if (avaliableTypes.length === 0) {
        throw new Error(`Magritte component Upload: accept can't be empty`);
    }
    if (avaliableTypes.length > 1) {
        return 'mixed';
    }
    return getFileType(avaliableTypes[0]);
};

// иконка (тип и цвет) может меняться в зависимости от типа, размера и состояния загрузки
export const getUploadIcon = (
    uploadType: UploadType,
    loadedFile: LoadedFile | undefined,
    isSmall: boolean
): ReactElement | undefined => {
    if (loadedFile) {
        const { error, loading } = loadedFile;
        if ((loading || error) && !isSmall) {
            return undefined;
        }
        if (uploadType === 'image') {
            return isSmall ? <ImageSize24 initial="accent" /> : <ImageSize32 initial="secondary" />;
        }
        if (uploadType === 'video') {
            return isSmall ? (
                <VideocameraOutlinedSize24 initial="accent" />
            ) : (
                <VideocameraOutlinedSize32 initial="secondary" />
            );
        }
        // mixed, application
        return isSmall ? <DocumentOutlinedSize24 initial="accent" /> : <DocumentOutlinedSize32 initial="secondary" />;
    }
    if (uploadType === 'video' || uploadType === 'image') {
        return isSmall ? <ImageSize24 initial="secondary" /> : <ImageSize32 initial="secondary" />;
    }
    // mixed, application
    return isSmall ? (
        <DocumentArrowUpOutlinedSize24 initial="secondary" />
    ) : (
        <DocumentArrowUpOutlinedSize32 initial="secondary" />
    );
};
